/**
 * Testa a imagem e retorna uma promise
 * @param src
 * @param cancelToken
 * @returns {Promise<unknown>}
 */
const testImage = (src, cancelToken = null) => {
    return  new Promise( (resolve, reject) => {
        if(src === null ||  src === undefined || src.trim() === ""){
            reject();
        }

        let img = new Image();

        const onCancel = () => {
            img.onload = null;
            img.onerror = null;
            img.src = null
            img = null;
            reject({ isCanceled: true });
        };

        if (cancelToken) {
            cancelToken.cancel = onCancel;
        }

        img.src = src;
        if(img.complete) resolve(src)
        img.onload = () =>  resolve(src)
        img.onerror = () =>  reject();
    })
}

/**
 *
 * @param src
 * @returns {*}
 */
const parseValidImage = (src) => {
    if(typeof src === "string"){
        return src.replace(/^.{1}(http|https)/, "$1")
    }
    return src;
}

export const ImageHelper  = {
    testImage,
    parseValidImage
}
